import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import {
  Popover,
  PopoverContent,
  PopoverPortal,
  PopoverTrigger,
} from "@/components/ui/popover";
import { formatTimeSaved } from "@/utils/time.utils";
import { TimeSavedPopoverContent } from "../time-saved-popover";
import { CLOCK_ICON } from "./widgets.constants";

interface TimeSavedWidgetProps {
  minutes: number;
  /** Whether the "view details" action is available. */
  hasSubscriptionAccess: boolean;
}

/** Accrued AI time-savings for the current month, with a details popover. */
export const TimeSavedWidget = ({
  minutes,
  hasSubscriptionAccess,
}: TimeSavedWidgetProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation(["common"]);

  return (
    <div className="hidden md:block">
      <Popover>
        <PopoverTrigger asChild>
          <button
            type="button"
            className="flex items-center gap-2 bg-white rounded-xs p-1 h-9 hover:bg-primary/5 transition-colors"
          >
            <img
              src={CLOCK_ICON}
              alt={t("common:chrome.time_saved")}
              draggable={false}
              className="size-6 object-contain shrink-0"
            />
            <span className="flex flex-col items-start leading-none pe-1">
              <span className="text-[12px] font-semibold tabular-nums text-foreground">
                {formatTimeSaved(minutes)}
              </span>
              <span className="text-[10px] font-normal text-muted-foreground mt-0.5">
                {t("common:chrome.this_month")}
              </span>
            </span>
          </button>
        </PopoverTrigger>
        <PopoverPortal>
          <PopoverContent
            className="w-96 p-0 rounded-xl overflow-hidden shadow-xl border-border/50 z-50"
            align="end"
            sideOffset={8}
          >
            <TimeSavedPopoverContent
              onViewDetails={
                hasSubscriptionAccess
                  ? () => navigate("/company/subscriptions/ai-token-usage")
                  : undefined
              }
            />
          </PopoverContent>
        </PopoverPortal>
      </Popover>
    </div>
  );
};
